<script>
export default {}
</script>

<template>
  <div :class="$style.block">
    <slot />
  </div>
</template>

<style lang="sass" module>
@import '../design/index.sass'
// @import '../design/style'

.block
  height: 100%
  padding: 0
  background: #F8F8F8
  -webkit-box-shadow: 0 3px 6px 0 rgba(197, 191, 200, 0.13)
  box-shadow: 0 3px 6px 0 rgba(197, 191, 200, 0.13)
</style>
